import { render } from "./chat-side-menu.vue?vue&type=template&id=6a77d07d&scoped=true"
import script from "./chat-side-menu.vue?vue&type=script&lang=js"
export * from "./chat-side-menu.vue?vue&type=script&lang=js"

import "./chat-side-menu.vue?vue&type=style&index=0&id=6a77d07d&lang=scss"
import "./chat-side-menu.vue?vue&type=style&index=1&id=6a77d07d&lang=scss&scoped=true"

import exportComponent from "/Users/apple/Documents/Full Stack Projects/elghoneimy-service-fullstack/source/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a77d07d"]])

export default __exports__